<form [formGroup]="formGroupRef">
    <div class="form-section">
      <div class="form-section-header">
        Send Message
      </div>
      <div class="form-section-content">
        <div class="mt-2" formGroupName="recipient">
          <mat-form-field class="mr-2" *ngIf="!value.messageKey">
            <mat-label>To</mat-label>
            <mat-select (selectionChange)="onRecipientChanged()" formControlName="clientKey">
              <mat-option [value]="null"></mat-option>
              <mat-option *ngFor="let recipient of recipients"
                          [value]="recipient.clientKey">{{recipient.lastName}}, {{recipient.firstName}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="mt-2" *ngIf="value.messageKey">
          <div>From:&nbsp;{{value?.recipient?.lastName}}, {{value?.recipient?.firstName}}</div>
          <div>To:&nbsp;{{value?.sender?.lastName}}, {{value?.sender?.firstName}}</div>
        </div>
        <div class="mt-2">
          <mat-form-field class="mr-2 full-width">
            <mat-label>Subject</mat-label>
            <input [readonly]="!!value.messageKey" matInput type="text" formControlName="subject">
          </mat-form-field>
        </div>
        <div class="mt-2">
          <div class="editor-override" *ngIf=!value.messageKey>
            <editor
              *ngIf="editorConfig"
              class="mt-2"
              formControlName="htmlContent"
              [apiKey]="tinyMceLicenseKey"
              [init]="editorConfig">
            </editor>
          </div>
          <div *ngIf="value.messageKey">
            <div style="height: 100%" [innerHtml]="value.htmlContent | safeHtml"></div>
          </div>
        </div>
      </div>
    </div>
</form>
